import React, { useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { WithdrawalInputBase } from './WithdrawalInputBase';

import { compareBigNumbers } from '@/shared/utils/helpers';
import { useModal } from '@/components/Modals/ModalWrapperHooks';

export const WithdrawalAmountField = ({ name }: { name: string }) => {
    const { control } = useFormContext();
    const { modalProps } = useModal();

    const { tokenSymbol, decimals, lpTokenBalance, totalPosition, totalProfit, poolBalance } =
        modalProps || {};

    const maxBalance = useMemo(() => {
        return compareBigNumbers(totalPosition!, poolBalance, decimals) === 1
            ? poolBalance
            : totalPosition;
    }, [totalPosition, totalProfit, decimals, poolBalance]);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <WithdrawalInputBase
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    tokenSymbol={tokenSymbol}
                    poolBalance={poolBalance}
                    decimals={decimals}
                    totalProfit={totalProfit}
                    totalPosition={totalPosition}
                    lpTokenBalance={lpTokenBalance}
                    disabled={Number(poolBalance) === 0}
                    maxBalance={maxBalance}
                />
            )}
        />
    );
};
